import { useQuery } from "@tanstack/react-query";
import { getRevenueMachineApi } from "../../services";
import { useRevenueMachine, useRevenueStore } from "../../store";

export const useGetRevenueMachineApi = () => {
  const { storeId } = useRevenueMachine();
  const { endDate, startDate } = useRevenueStore()

  const { data, isLoading } = useQuery({
    queryKey: ["revenue-machine", startDate, endDate, storeId],
    queryFn: () => getRevenueMachineApi(storeId, startDate, endDate),
    enabled: true,
  });
  return {
    revenueMachine: data,
    isLoading,
  };
};
